import api from './api';

export async function fetchDeliveryDelays() {
  const { data } = await api.get('/api/delivery-delays');
  return data;
}
